import { useEffect, useState } from 'react';

import { getBalanceCorrectionsRequest } from '@epi-api/balanceCorrections';
import { CorrectionDetails } from '@epi-models/pages/Reports';

export const useBalanceCorrections = () => {
  const [reports, setReports] = useState<CorrectionDetails[]>([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [showCalendar, setShowCalendar] = useState(false);
  const [timePeriodType, setTimePeriodType] = useState<string>();
  const [from, setFrom] = useState<string | Date | null>(null);
  const [to, setTo] = useState<string | Date | null>(null);

  const handleChangePage = (newPage: number) => {
    setPage(newPage);
  };

  const getReports = async () => {
    const formattedFrom =
      typeof from === 'object' ? from?.toLocaleDateString('sv-SE') : from;
    const formattedTo =
      typeof to === 'object' ? to?.toLocaleDateString('sv-SE') : to;
    const response = await getBalanceCorrectionsRequest(
      page,
      from ? `${formattedFrom}T00:00:00.000Z` : '',
      to ? `${formattedTo}T23:59:00.000Z` : ''
    );
    setReports(response.transactions);
    setTotalPages(response.totalPages);
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);
    getReports();
  }, [page, from, to]);

  return {
    reports,
    page,
    totalPages,
    isLoading,
    showCalendar,
    setShowCalendar,
    timePeriodType,
    handleChangePage,
    from,
    to,
    setFrom,
    setTo,
    setPage,
    setTimePeriodType
  };
};
